import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=58cbcfd8&scoped=true"
import script from "./addressDetail.vue?vue&type=script&lang=js"
export * from "./addressDetail.vue?vue&type=script&lang=js"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=58cbcfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbcfd8",
  null
  
)

export default component.exports